<template>
	<HmAuthenticationLayout app="auth">
		<slot />
	</HmAuthenticationLayout>
</template>
